<template>
	<div>
		<div class="footed_top">
			<div class="footed_top_main2">
				<div class="footed_top_main_l">
					<div style="margin-bottom: 40px;" class="dfs">
						<div class="footed_logo">
							<img src="../assets/anda_logo.png" />
						</div>
						<div style="color: #FFF;font-size: 14px;">北京安达思创管理顾问有限公司</div>
					</div>
					<div class="foot_df">
						<div class="footed_item">
							<div class="title">邮箱</div>
							<div class="s_title fw_m">adsc@adstrong.cn</div>
						</div>
						<div class="footed_item">
							<div class="title">电话</div>
							<div class="s_title fw_m">86-10-62750566</div>
							<!--<div class="s_title fw_m">周一至周五 09:00-18:00</div>-->
						</div>
						<div class="footed_item">
							<div class="title">地址</div>
							<div class="s_title fw_m">北京海淀区学院路万和大厦206室</div>
						</div>
					</div>
				</div>
				<div class="footed_top_main_r">
					<div>
						<img src="../assets/小鹅通.png" />
						<div>小鹅通</div>
						<div>（青少年行为管理与思维创新）</div>
					</div>
					<div>
						<img src="../assets/公众号.png" />
						<div>微信公众号</div>
						<div>（青少年创新项目管理集训营）</div>
					</div>
				</div>
			</div>
		</div>
		<div class="footed_bottom">Copyright © 京ICP备12012369号-1</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {}
		},
		methods: {

		}
	}
</script>

<style scoped="scoped">
	.footed_top {
		width: 100%;
		min-width: 1200px;
		/*height: 193px;*/
		background-color: #202124;
	}
	
	.footed_top_main2 {
		padding: 10px 0px;
		padding-bottom: 30px;
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-end;
	}
	
	.footed_top_main_l {
		margin-top: 30px;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: flex-start;
	}
	
	.footed_top_main_r {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
	}
	
	.footed_top_main_r>div {
		width: 200px;
		margin-right: 10px;
	}
	
	.footed_top_main_r>div:nth-child(2) {
		margin-right: 0px;
	}
	
	.footed_top_main_r div img {
		width: 100px;
		height: 100px;
		margin-bottom: 10px;
	}
	
	.footed_top_main_r div div {
		width: 200px;
		text-align: center;
		color: #fff;
		font-size: 14px;
	}
	
	.footed_logo {
		width: 155px;
		height: 46px;
		margin-right: 30px;
	}
	.foot_df{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
	}
	
	.footed_item {
		display: inline-block;
		text-align: left;
		margin-right: 60px;
	}
	
	.footed_item .title {
		font-size: 18px;
		line-height: 24px;
		margin-bottom: 11px;
		color: #fff;
	}
	
	.footed_item .s_title {
		font-size: 16px;
		line-height: 22px;
		color: rgb(144, 144, 146);
		margin-bottom: 8px;
	}
	
	.footed_bottom {
		width: 100%;
		min-width: 1200px;
		border-top: 1px solid rgb(144, 144, 146);
		height: 50px;
		text-align: center;
		background-color: #202124;
		line-height: 50px;
		font-size: 14px;
		color: rgb(144, 144, 146);
	}
</style>


// WEBPACK FOOTER //
// src/components/foot.vue